import * as React from "react";
import type { SVGProps } from "react";
const SvgPinLocation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M7 0a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7"
    />
  </svg>
);
export default SvgPinLocation;
